import { useRef, useEffect } from 'react';
import QRCode, { type QRCodeRenderersOptions } from 'qrcode';

interface Props extends QRCodeRenderersOptions {
  children: string;
}

export function QrCode({ children, ...options }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    QRCode.toCanvas(canvasRef.current, children, options).catch((error) =>
      // TODO: handle errors properly
      console.error(error),
    );
  }, [children, options]);
  return (
    <canvas ref={canvasRef} width={options.width} height={options.width} />
  );
}
